import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import framework_image from '../../../../img/framework_img.png'
import ErrorAlert from '../../../../components/alerts/components/BorderedAlertsWithIcons';
import { render_field, render_phone_field } from '../../../../utils/renderField';
import { withRouter } from 'react-router-dom'
class GetBasicInfo extends Component {
  state = {
    loading: null,
    errorMessage: false
  }
  componentDidMount () {
    const { fName, lName, telephone, company_name, industry, country, email_address } = this.props.fields;
    this.props.dispatch(change('getBasicInfoForm', 'email_address', email_address));
    this.props.dispatch(change('getBasicInfoForm', 'fName', fName));
    this.props.dispatch(change('getBasicInfoForm', 'lName', lName));
    this.props.dispatch((change('getBasicInfoForm', 'telephone', telephone)));
    this.props.dispatch(change('getBasicInfoForm', 'company_name', company_name));
    this.props.dispatch(change('getBasicInfoForm', 'industry', industry));
    this.props.dispatch(change('getBasicInfoForm', 'country', country));
  }

  onSubmit () {
    const fields = this.props.fields;

    this.setState({ loading: true })

    fetch("https://9hh760b1ph.execute-api.us-west-2.amazonaws.com/qa/signupEmail", {
      method: "POST",
      mode: "cors",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        firstName: fields.fName,
        lastName: fields.lName,
        phoneNumber: fields.telephone,
        environmentName: fields.company_name,
        email: fields.email_address
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      if (data) {
        this.setState({ loading: false })
        this.props.history.push('/confirmation');
      }
      else {
        this.setState({ errorMessage: true });
      }
    })
  }

  render () {
    const { fName, lName, company_name, telephone, email_address } = this.props.fields;
    const { handleSubmit } = this.props;

    return (
      <div id="trial-signup">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <img src={framework_image} alt="Posture-signup" style={{ marginBottom: '15px', width: '25vw', minWidth: '200px', maxWidth: '340px' }} />
          <p style={{ fontSize: '14px' }}>Already have an account? <a id='signinLink' href='http://app.postured.io/login'>Login</a></p>
        </div>

        <div className="col-md-6 col-sm-6 col-xs-12">
          {this.state.errorMessage ? <div style={{ marginTop: "-30px" }}> <ErrorAlert level='danger' msg='An error has occured!' alertTag={'Error'} /> </div> : null}
          <form className='form' onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <div style={{ width: "100%" }}>
              <h3 className='formHeader'> Join Posture's Beta for free</h3>
              <p className='description'>Enter your professional details so we know who you are.</p>
            </div>
            <div className='form__form-group'>
              <div style={{ display: 'flex' }}>
                <div className='form__form-group-field' style={{ paddingRight: 8 }}>
                  <Field
                    id='name'
                    name='fName'
                    value={fName}
                    component={render_field}
                    type='text'
                    placeholder='Your First Name'
                    onChange={this.props.handleChange}
                    defaultValue={fName}
                  />
                </div>

                <div className='form__form-group-field'>
                  <Field
                    id='name'
                    name='lName'
                    value={lName}
                    component={render_field}
                    type='text'
                    placeholder='Your Last Name'
                    onChange={this.props.handleChange}
                    defaultValue={lName}
                  />
                </div>

              </div>

              <div style={{ display: 'flex' }}>
                <div className='form__form-group-field'>
                  <Field
                    id='company_name'
                    name='company_name'
                    value={company_name}
                    component={render_field}
                    type='text'
                    placeholder='Your Company Name'
                    onChange={this.props.handleChange}
                    defaultValue={company_name}
                  />
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div className='form__form-group-field' style={{ paddingRight: 8 }}>
                  <Field
                    id='telephone'
                    name='telephone'
                    value={telephone}
                    component={render_phone_field}
                    type='text'
                    placeholder='+1 (555) 555-5555'
                    onChange={this.props.handleChange}
                    defaultValue={telephone}
                  />
                </div>

                <div className='form__form-group-field'>
                  <Field
                    id='email_address'
                    name='email_address'
                    value={email_address}
                    component={render_field}
                    type='text'
                    placeholder='Email Address'
                    onChange={this.props.handleChange}
                    defaultValue={email_address}
                  />
                </div>
              </div>
            </div>

            <div style={{
              //display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              alignContent: 'center',
              width: '100%',
              paddingTop: 12
            }}>
              {/*<span className='arrow'>
            <LeftArrow
              style ={{fill:'#AEB8C4', verticalAlign: 'middle'}}
              onClick={() => { this.props.back() }}
            />
      </span>*/}
              {this.state.loading ? <button className='loadingBtn' style={{ cursor: 'progress' }} type='button' disabled={this.state.loading}> Saving Your Response...</button>
                : <button className='onBoardingBtn' style={{ cursor: "pointer", width: '100%' }}> Create My Posture Environment </button>}
            </div>
          </form>
        </div>
      </div>
    )
  }
}




function validate (values) {
  let errors = {};

  const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const nameRe = /[a-zA-z]/
  const companyRe = /[$-/:-?{-~!"^_`\[\]a-zA-z0-9]/
  const telephoneRe = /\+\d \(\d{3}\) \d{3}-\d{4}/g

  // Validate the inputs from the values object

  if (!values.email_address) {
    errors.email_address = "Enter your email address";
  }

  if (!re.test(values.email_address)) {
    errors.email_address = "Enter a correct email address";
  }

  if (!values.telephone) {
    errors.telephone = "Enter your phone number"
  }

  if (!values.fName) {
    errors.fName = "Enter your first name";
  }

  if (!nameRe.test(values.fName)) {
    errors.fName = "Enter a valid first name";
  }

  if (!telephoneRe.test(values.telephone)) {
    errors.telephone = "Enter a valid phone number";
  }

  if (!values.lName) {
    errors.lName = "Enter your last name";
  }

  if (!nameRe.test(values.lName)) {
    errors.lName = "Enter a valid last name";
  }

  if (!values.company_name) {
    errors.company_name = "Enter your company name";
  }

  if (!companyRe.test(values.company_name)) {
    errors.company_name = "Enter a valid company name";
  }


  return errors
}

export default reduxForm({
  form: "getBasicInfoForm",
  validate
})(withRouter(GetBasicInfo));



// WEBPACK FOOTER //
// ./src/pages/account/register/components/getBasicInfo.js